var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4136_1527)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9437 1.5H4.05634C2.64451 1.5 1.5 2.64451 1.5 4.05634V67.9437C1.5 69.3555 2.64451 70.5 4.05634 70.5H67.9437C69.3555 70.5 70.5 69.3555 70.5 67.9437V4.05634C70.5 2.64451 69.3555 1.5 67.9437 1.5ZM4.05634 0H67.9437C70.1839 0 72 1.81608 72 4.05634V67.9437C72 70.1839 70.1839 72 67.9437 72H4.05634C1.81608 72 0 70.1839 0 67.9437V4.05634C0 1.81608 1.81608 0 4.05634 0Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.3358 10 56.75C10 57.1642 10.2239 57.5 10.5 57.5H61.5C61.7761 57.5 62 57.1642 62 56.75C62 56.3358 61.7761 56 61.5 56Z",
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4481 34.4491C16.9363 33.961 17.7278 33.961 18.2159 34.4491L25.9987 42.2319L33.7815 34.4491C34.2696 33.961 35.0611 33.961 35.5492 34.4491C36.0374 34.9373 36.0374 35.7287 35.5492 36.2169L26.8826 44.8836C26.3944 45.3717 25.603 45.3717 25.1148 44.8836L16.4481 36.2169C15.96 35.7287 15.96 34.9373 16.4481 34.4491Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4508 27.5509C15.9626 27.0627 15.9626 26.2713 16.4508 25.7831L25.1174 17.1164C25.6056 16.6283 26.397 16.6283 26.8852 17.1164L35.5519 25.7831C36.04 26.2713 36.04 27.0627 35.5519 27.5509C35.0637 28.039 34.2722 28.039 33.7841 27.5509L26.0013 19.7681L18.2185 27.5509C17.7304 28.039 16.9389 28.039 16.4508 27.5509Z",
    fill: "#4D4D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4136_1527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDropdown);
export default __webpack_public_path__ + "static/media/custom-dropdown.3210c9fb42d69fad41fd989a7f143ec9.svg";
export { ForwardRef as ReactComponent };